import { styled, Typography, TypographyProps } from "@mui/material"

export const StyledTitle = styled(Typography)<
  TypographyProps & { component: string }
>`
  padding: 1rem;
`
